/* Rose Lane — editorial card variant binding (swatch → image / hover image /
   link / add-to-cart). Loaded once, deferred, by the snippets that bind cards
   (rl-products-carousel-script, card-product inline, rl-section-sets); their
   inline glue queues its binding in window.RLCardLibQueue until this file has
   run. Was an inline snippet rendered with every carousel instance. */
if (!window.RLEditorialVariantCard) {
  window.RLEditorialVariantCard = {
    bind: function (card, options) {
      var img = card.querySelector(options.imageSelector);
      var media = card.querySelector(options.mediaSelector);
      var hoverImg = card.querySelector(options.hoverSelector);
      var link = card.querySelector(options.linkSelector);
      var baseHref = link ? link.getAttribute('href') : '';
      var atcForm = card.querySelector('[data-rl-atc-form]');
      var atcVariant = card.querySelector('[data-rl-atc-variant]');
      var atcBtn = card.querySelector('[data-rl-atc-button]');
      var atcLabel = card.querySelector('.rl-atc__label');
      var pendingHoverSrc = '';
      var hoverLeaveBound = false;

      function preloadAndSwap(target, newSrc, onSwap) {
        if (!target) return;
        target.dataset.rlExpectedSrc = newSrc || '';
        if (!newSrc) return;
        var preload = new Image();
        preload.onload = function () {
          if (target.dataset.rlExpectedSrc !== newSrc) return;
          target.removeAttribute('srcset');
          target.setAttribute('src', newSrc);
          if (typeof onSwap === 'function') onSwap();
        };
        preload.src = newSrc;
      }

      function syncHoverOnLeave() {
        if (hoverLeaveBound && media) {
          media.removeEventListener('mouseleave', syncHoverOnLeave);
          hoverLeaveBound = false;
        }
        if (!hoverImg) return;
        var hoverSrc = pendingHoverSrc;
        if (!hoverSrc) {
          preloadAndSwap(hoverImg, '');
          hoverImg.style.display = 'none';
          card.classList.add('is-variant-hover-empty');
          card.classList.remove('is-variant-hover-suppressed');
          return;
        }
        preloadAndSwap(hoverImg, hoverSrc, function () {
          if (pendingHoverSrc === hoverSrc) {
            hoverImg.style.display = '';
            card.classList.remove('is-variant-hover-empty');
            card.classList.remove('is-variant-hover-suppressed');
          }
        });
      }

      function scheduleHoverSwap(hoverSrc) {
        if (!hoverImg) return;
        pendingHoverSrc = hoverSrc || '';
        card.classList.add('is-variant-hover-suppressed');
        card.classList.toggle('is-variant-hover-empty', !pendingHoverSrc);
        hoverImg.style.display = 'none';
        if (!media || !media.matches || !media.matches(':hover')) {
          syncHoverOnLeave();
          return;
        }
        if (!hoverLeaveBound) {
          hoverLeaveBound = true;
          media.addEventListener('mouseleave', syncHoverOnLeave);
        }
      }

      var radios = card.querySelectorAll(options.radioSelector);

      /* Single-swatch shortcut : when only one swatch is rendered (single
         variant on Color, shown for visual parity with multi-variant
         siblings), the swatch can't change variants — let a click on its
         label go through RLQuickAdd just like the ATC button. Saves a
         roundtrip on cards where swatch + ATC sit side by side and would
         otherwise look like two redundant CTAs. Opt-in via
         options.singleSwatchSubmits to keep other surfaces (Sets,
         products carousel) unchanged. */
      if (options.singleSwatchSubmits && radios.length === 1 && atcForm && atcBtn) {
        var soloRadio = radios[0];
        var soloLabel = soloRadio.id ? card.querySelector('label[for="' + soloRadio.id + '"]') : null;
        if (soloLabel) {
          soloLabel.addEventListener('click', function (evt) {
            if (atcBtn.disabled || !window.RLQuickAdd) return;
            evt.preventDefault();
            window.RLQuickAdd.submit(atcForm);
          });
        }
      }

      /* Resync after back-navigation. Two browser mechanisms can leave
         the form in an inconsistent state — the radio is checked on a
         non-default variant, but `data-rl-atc-variant` (set in the
         `change` handler) is stuck on the Liquid-rendered default :
           1. bfcache restore : DOM is frozen-then-thawed, `change`
              never fires → handled by `pageshow.persisted`.
           2. Form state restoration on a normal reload : Chrome/Firefox
              restore the <input> selections post-DOMContentLoaded
              without firing `change`. The hidden ATC input keeps its
              Liquid-rendered value.
         Run a sync pass at init (just after binding) and also on
         pageshow — any mismatch between `:checked` radio and the
         tracked ATC variant id refires `change` to bring everything
         back in line (variant id, PDP link, label, disabled state). */
      function resyncFromCheckedRadio() {
        var active = card.querySelector(options.radioSelector + ':checked');
        if (!active) return;
        var radioVid = active.getAttribute('data-variant-id');
        var atcVid = atcVariant ? atcVariant.value : null;
        if (!radioVid || radioVid === atcVid) return;
        active.dispatchEvent(new Event('change', { bubbles: true }));
      }

      window.addEventListener('pageshow', resyncFromCheckedRadio);
      /* Defer to next tick so the browser has time to restore form
         state from history before we compare. */
      setTimeout(resyncFromCheckedRadio, 0);

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          preloadAndSwap(img, radio.getAttribute('data-image'));
          scheduleHoverSwap(radio.getAttribute('data-hover-image') || '');

          var vid = radio.getAttribute('data-variant-id');
          if (vid) {
            if (atcVariant) atcVariant.value = vid;
            if (link && baseHref) link.setAttribute('href', baseHref.split('?')[0] + '?variant=' + vid);
          }
          if (atcForm && atcBtn) {
            var available = radio.getAttribute('data-available') !== 'false';
            /* Cache the initial label rendered by Liquid on first interaction
               so we can restore it even if the form has no data-label attr
               (older snippet version, or missing setting). Critical : never
               wipe a non-empty label by an empty data-label fallback —
               losing the button text breaks add-to-cart visibility. */
            if (!atcForm.dataset.rlInitialLabel && atcLabel) {
              atcForm.dataset.rlInitialLabel = atcLabel.textContent;
            }
            var attrLabel = atcForm.getAttribute('data-label');
            var labelText = attrLabel != null && attrLabel !== ''
              ? attrLabel
              : (atcForm.dataset.rlInitialLabel || '');
            var attrSoldOut = atcForm.getAttribute('data-sold-out-label');
            var soldOutText = attrSoldOut != null && attrSoldOut !== ''
              ? attrSoldOut
              : 'Épuisé';
            atcForm.classList.toggle('rl-atc--disabled', !available);
            atcBtn.disabled = !available;
            if (available) {
              atcBtn.removeAttribute('aria-disabled');
            } else {
              atcBtn.setAttribute('aria-disabled', 'true');
            }
            if (atcLabel) {
              var nextLabel = available ? labelText : soldOutText;
              /* Skip the swap if it would leave the button empty, AND skip
                 if the label has structured children (the letter-spread
                 preset wraps each character in its own span — a textContent
                 swap would flatten them and break the per-letter animation).
                 In that case rely on the form's disabled state for the
                 sold-out signal. */
              var hasLetterStructure = atcLabel.querySelector('.rl-atc__letter');
              if (nextLabel && !hasLetterStructure) {
                atcLabel.textContent = nextLabel;
              }
            } else {
              var visible = available ? labelText : soldOutText;
              if (visible) {
                atcBtn.setAttribute('aria-label', visible);
                atcBtn.setAttribute('title', visible);
              }
            }
          }
        });
      });
    }
  };
}

/* Bindings queued by the inline glue while this file was still loading. */
(function () {
  var queue = window.RLCardLibQueue || [];
  window.RLCardLibQueue = { push: function (fn) { fn(); } };
  queue.forEach(function (fn) { fn(); });
})();
